/**
 * The browser's History API as the Router's HistoryPort. Kept in the app
 * (composition root), so the Router itself never touches `window`.
 */
import type { HistoryPort } from "../editor/router/Router";

export function browserHistory(win: Window): HistoryPort {
  return {
    get pathname() {
      return win.location.pathname;
    },
    get search() {
      return win.location.search;
    },
    push: (url) => {
      win.history.pushState(null, "", url);
    },
    replace: (url) => {
      win.history.replaceState(null, "", url);
    },
    onPopState: (listener) => {
      win.addEventListener("popstate", listener);
      return () => {
        win.removeEventListener("popstate", listener);
      };
    },
  };
}
